import { LAYOUT, getParentLayout } from '../../constant'

const page = {
  path: '/page',
  // redirect: '/page/list',
  component: LAYOUT,
  meta: {
    title: '页面',
    menuTitle: '页面DEMO',
    orderNo: 3
  },
  children: [
    {
      path: 'list',
      name: 'pageList',
      redirect: '/page/list/basic',
      component: getParentLayout(),
      meta: {
        title: '订单管理'
      },
      children: [
        {
          path: 'basic',
          name: 'formBasic',
          component: () => import('@/views/page/form/Basic.vue'),
          meta: {
            title: '基础表单'
            // currentActiveMenu: '/page/list'
          }
        },
        {
          path: 'form',
          name: 'FormHorizontal',
          component: () => import('@/views/page/form/Horizontal.vue'),
          meta: {
            title: '基础表单-横向'
          }
        }
      ]
    },
    {
      path: 'orderDetail',
      name: 'OrderDetail',
      component: () => import('@/views/order/Detail.vue'),
      meta: {
        title: '订单详情'
      }
    }
  ]
}

export default page
